import { tI18nDefinition } from "oweb";

export default {} as tI18nDefinition;
